import { type } from '@/utils/type'

export const AUTH_REQUEST = type('AUTH_REQUEST')
export const AUTH_SUCCESS = type('AUTH_SUCCESS')
export const AUTH_ERROR = type('AUTH_ERROR')
export const AUTH_CHANGEPASSWORD_REQUEST = type('AUTH_CHANGEPASSWORD_REQUEST')
export const AUTH_CHANGEPASSWORD_SUCCESS = type('AUTH_CHANGEPASSWORD_SUCCESS')
export const AUTH_CHANGEPASSWORD_ERROR = type('AUTH_CHANGEPASSWORD_ERROR')
export const AUTH_LOGOUT = type('AUTH_LOGOUT')
export const AUTH_USER_REQUEST = type('AUTH_USER_REQUEST')
export const AUTH_USER_SUCCESS = type('AUTH_USER_SUCCESS')
export const AUTH_USER_ERROR = type('AUTH_USER_ERROR')
export const AUTH_AUTO_RENEW = type('AUTH_AUTO_RENEW')
export const AUTH_RESET_STATUS = type('AUTH_RESET_STATUS')
export const AUTH_PASSWORD_REQUEST = type('AUTH_PASSWORD_REQUEST')
export const AUTH_PASSWORD_SUCCESS = type('AUTH_PASSWORD_SUCCESS')
export const AUTH_PASSWORD_ERROR = type('AUTH_PASSWORD_ERROR')
export const AUTH_CREATE_PASSWORD_REQUEST = type('AUTH_CREATE_PASSWORD_REQUEST')
export const AUTH_CREATE_PASSWORD_SUCCESS = type('AUTH_CREATE_PASSWORD_SUCCESS')
export const AUTH_CREATE_PASSWORD_ERROR = type('AUTH_CREATE_PASSWORD_ERROR')
export const AUTH_CHANGEPASSWORD_RESET_STATUS = type('AUTH_CHANGEPASSWORD_RESET_STATUS')
